import types from '../types'

const initialState = {
  show: false,
  years: 4
}

const synopsisReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SHOW_SYNOPSIS: {
    return {
      ...state,
      show: action.payload
    }
  }
  case types.SET_YEARS: {
    return {
      ...state,
      years: parseInt(action.payload, 10)
    }
  }
  default:
    return state
  }
}

export default synopsisReducer